<template>
  <b-modal class="modal-xl" size="lg" id="einvoicemodal" ref="einvoicemodal" no-close-on-backdrop no-close-on-esc scrollable hide-backdrop busy hide-header hide-footer style="z-index: 10000">
    <template slot="default" slot-scope="data">
      <div class="col-12">
        <div class="col-12" v-if="modalVariant">
          <h1 class="col-12">Welcome to E-Invoicing</h1>
          <p class="col-12">Dear Customer,</p>
          <p class="col-12">We have the pleasure to inform you that Ralph Lauren Europe Sàrl and its European affiliates (hereinafter together “Ralph Lauren”) are ready to send you electronic invoices.
          <br/>This  allow you to receive your invoice by electronic means and lower the amount of paper invoices for your company.</p>
          <p class="col-12">Ralph Lauren took the necessary steps to send you VAT compliant electronic invoices, in accordance with EU Directive 2006/112/EC of November 28, 2006.
          <br/>In accordance with this Directive, Ralph Lauren needs to receive a confirmation that your company agrees with receiving electronic invoices from Ralph Lauren.</p>
          <ul class="col-12">
            <li class="col-12 mb-3">
              <div class="col-12 mb-1">Please confirm that you accept to receive electronic invoices from Ralph Lauren.</div>
              <!-- if user_details->einvoicing then set the input to checked and disabled -->
              <div class="col-12">
                <div class="col-12" style="display: flex; align-items: center;">
                  <b-form-checkbox class="mr-1" id='einvoicing' name="einvoicing" value="1" unchecked-value="0" v-model="user_details.einvoicing"><b>I Accept</b></b-form-checkbox>
                </div>
              </div>
              <div class="col-12" v-if="user_details.einvoicing_accepted">
                <p class="mb-0 mt-1" style="color:red; font-size: 11px;">
                  <b>Note: Eletronic invoicing was first accepted on {{ user_details.einvoicing_accepted }}</b>
                </p>
              </div>
              <div class="col-12 mb-1">
                Please note that once you move to e-invoicing we will stop sending paper invoices to you.
              </div>	
            </li>
            <li class="col-12 mb-3">
              <p>Please indicate the email address in which you would like to receive your invoices</p>	
              <input type="text" name="email" v-model="user_details.email" />
            </li>
            <li class="col-12 mb-3">
              <p class="mb-1">Please specify electronic option preference for e-invoicing</p>
              <div class="col-12">
                <b-form-radio-group v-model="user_details.electronic_option">
                  <div class="col-12" style="display: flex; align-items: center;">
                    <b-form-radio class="mr-1" value="email_doc"><b>Email with PDF attachment</b></b-form-radio>
                  </div>
                  <div class="col-12" style="display: flex; align-items: center;">
                    <b-form-radio class="mr-1" value="email_link"><b>Email with link to portal</b></b-form-radio>
                  </div>
                </b-form-radio-group>
              </div>
              <div class="col-12 mt-2">
                <p>By submitting your response you confirm that you have the right and authority to agree on invoicing procedures on behalf of {{ user_details.name }} ({{user_details.reference}}), {{user_details.postal_address}}</p>
              </div>
            </li>
          </ul>
          <div class="col-12 mt-3">
            <p><i>From now onwards you will receive all your invoices in electronic format.</i></p>
          </div>	
          <div class="col-12">
            <p><i>For your records this is the email address:  RalphLauren_DO_NOT_REPLY@netsend.biz from which you will receive Ralph Lauren invoices.</i></p>
          </div>
          <div class="col-12">
            <button class="btn btn-primary" type="submit" :disabled="user_details.einvoicing == 0" @click="submitEInvoice()" style="font-weight:bold;width:100px" value="Submit">Submit</button>
          </div>
          <div class="col-12 mt-3 mb-2" style="display: flex; align-items: center;">
            <b-form-checkbox class="mr-2" v-model="user_details.once_month" type="checkbox" name="once_month" value="1" unchecked-value="0"></b-form-checkbox>
            <b class="mb-0">
              Tick here to see this page only once a month (instead of every time you logon)
            </b>
          </div>
          <div class="col-12" style="display: flex; align-items: center;">
            <p class="mb-3">
              <button class="btn btn-secondary" @click="skipInvoiceModal()" type="submit" id='einv_skip' name="action" style="font-weight:bold;width:100px" value="Skip">Skip</button>
            </p>
          </div>
        </div>
        <div class="col-12 text-center" v-else>
          <h1 class="col-12">Your Details</h1>
          <div class="col-12" v-if="clientName != 'brew'">
            <p>Use this form to update any contact details we currently hold for you.</p>
          </div>
          <div class="col-12" v-else>
            <p>Please contact your investment manager if there are any changes in your details</p>
          </div>
          <div class="col-12 text-center">
            <div class="col-12 text-center center-flex mb-1">
              <div class="text-left mr-2" style="font-weight: bold; width: 120px;">Email address:</div>
              <div>
                <div v-if="clientName == 'brew' || clientName == 'brewtest'">
                  <input class="form-control" v-model="user_details.email" type="text" name="email" style="width:260px" readonly />
                </div>
                <div v-else>
                  <input class="form-control" v-model="user_details.email" type="text" name="email" style="width:260px" />
                </div>
              </div>
            </div>
            <!-- client.show_details_form -->
            <!-- this comes from clients table -->
            <!-- DONT FORGET TO MAKE IF CHECK FOR TRUE , TEST -->
            <div class="col-12 text-center" v-if="user_details.show_details_form">
              <div class="col-12 center-flex mb-1">
                <div class="text-left mr-2" style="font-weight:bold; width: 120px;">Company name:</div>
                <div>
                  <input class="form-control" type="text" name="name" v-model="user_details.name" style="width:260px"/>
                </div>
              </div>
              <div class="col-12 center-flex mb-1">
                <div class="text-left mr-2" style="font-weight:bold; width: 120px;">Contact name:</div>
                <div>
                  <input class="form-control" type="text" name="contact_name" v-model="user_details.contact_name" style="width:260px"/>
                </div>
              </div>
              <div class="col-12 center-flex mb-1">
                <div class="text-left mr-2" style="font-weight:bold; width: 120px;">Address for:</div>
                <div>
                  <textarea class="form-control" style="width:260px; height:120px; font-size:98%;" name="postal_address" v-model="user_details.postal_address"></textarea>
                </div>
              </div>
            </div>
            <!-- v-if="clientName == 'ralp' || clientName == 'ralptest'" -->
            <div class="col-12 center-flex mb-1">
              <div class="text-left mr-2" style="font-weight:bold; width: 120px;">Country:</div>
              <div style="width:260px;">
                <!-- set select to disabled is user details country is set -->
                <select v-model="user_details.country" class="form-control" style="width:260px;" name="country">
                  <option></option>
                  <!-- {if ($user_details->country == $country->code)}selected="selected"{/if} -->
                  <option v-for="country in countryList" :key="country.id" :value="country.id">{{ country.name }}</option>
                </select>
                <div v-if="!user_details.country">
                  <sub name='country_message' style="color:red;"><b>Please select a your country to continue</b></sub>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-center mt-2" style="font-weight:bold; text-align:right;">
            <div class="col-12 text-center center-flex">
              <div class="text-center center-flex" style="display: inline-block;">
                Tick here to see this page only once a month  <br>
                (instead of every time you logon)
              </div>
              <div class="center-flex ml-3">
                <b-form-checkbox type="checkbox" v-model="user_details.once_month" name="once_month" value="1" unchecked-value="0"></b-form-checkbox>
              </div>
            </div>
          </div>
          <div class="col-12 mt-2">
            <ResponseInfo v-if="getResponseInfo.responseName == 'homepageModal'"></ResponseInfo>
          </div>
          <div v-if="user_details.country" class="col-12 text-center mt-3" style="vertical-align:middle; text-align:right;">
            <div class="col-12">
              <input class="btn btn-primary mb-1" type="submit" name="switch_advanced" value="View delivery options" style="font-weight:bold; width:180px;" @click="toggleDeliveryOption()"/>
              <br>
              <strong class="mr-3" id="strong_or">or</strong>
              <input class="btn btn-secondary" @click="submitEInvoice" type="submit" name="detail_update" value="Next" style="font-weight:bold; width:100px"/>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'RalpEInvoiceForm',
  props: ['eInvoiceModal', 'userDetails', 'showModal'],
  data() {
    return {
      user_details: {
        contact_name: '', // NEED CONTACT NAME
        postal_address: '', // SAME AS BELOW
        old_postal_address: '', // NEED POSTAL ADDRESS
        country: '', //
        name: '', //
        email: '', //
        oldEmail: '', //
        einvoicing_accepted: true, //
        einvoicing: null, //
        allow_data: '', //
        email_subject: '', //
        receiving: true, //
        reference: '', //
        modalOption: 0,
        once_month: 0
      },
      modalVariant: false,
      countryList: null,
      showModal: false,
      need_delivery_option: false
    }
  },
  methods: {
    toggleDeliveryOption() {
      this.need_delivery_option = 1
      this.submitEInvoice()
    },
    getCountryList() {
      // if client is ralp and the conditions at the top are not fulfilled
      this.$store.dispatch("homepageStore/getCountryList").then(response => {
        this.countryList = response
      })
    },
    skipInvoiceModal() {
      this.$store.dispatch("homepageStore/skipEInvoice").then(response => {
        this.modalOpen = false
        this.$parent.showEinvoiceModal = false
        this.$bvModal.hide('einvoicemodal')
        this.$store.commit('setEinvoicingStatus', false)
      })
    },
    submitEInvoice() {
      this.$store.commit('setEinvoicingStatus', false)
      // based on the modal we display we send different variables to the backend
      if(this.modalVariant) {
        this.$store.dispatch("homepageStore/submitEInvoice", {
          einvoicing: this.user_details.einvoicing,
          old_einvoicing: this.user_details.old_einvoicing,
          email: this.user_details.email,
          old_email: this.user_details.old_email,
          electronic_option: this.user_details.electronic_option,
          allow_data: this.user_details.allow_data,
          email_subject: this.user_details.email_subject,
          once_month: this.user_details.once_month,
          einvoicing_accepted: this.user_details.einvoicing_accepted
        }).then((response) => {
          if(response.status == 'success') {
            this.modalOpen = false
            this.$parent.showEinvoiceModal = false
            this.$bvModal.hide('einvoicemodal')
          }
        })
      } else {
        this.$store.dispatch("homepageStore/submitEInvoice", {
          name: this.user_details.name,
          old_name: this.user_details.old_name,
          email: this.user_details.email,
          old_email: this.user_details.old_email,
          contact_name: this.user_details.contact_name,
          old_contact_name: this.user_details.old_contact_name,
          postal_address: this.user_details.postal_address,
          old_postal_address: this.user_details.old_postal_address,
          country: this.user_details.country,
          once_month: this.user_details.once_month,
          need_delivery_option: this.need_delivery_option
        }).then((response) => {
          if(response.status) {
            if(response.status == 'success') {
              this.modalOpen = false
              this.$parent.showEinvoiceModal = false
              this.$bvModal.hide('einvoicemodal')
            }
          } else {
            this.modalOpen = false
            this.$parent.showEinvoiceModal = false
            this.$bvModal.hide('einvoicemodal')
          }
        })
      }

    }
  },
  created() {
    this.getCountryList()

    if(this.$props) {
      this.user_details = this.$props.userDetails
      this.user_details.email = this.getUserDetails.email
      this.user_details.old_email = this.getUserDetails.email
      this.user_details.old_postal_address = this.$props.userDetails.postal_address
      this.user_details.old_einvoicing = this.$props.userDetails.einvoicing
      this.modalOpen = this.$props.showModal
      this.modalVariant = this.$props.eInvoiceModal,
      this.user_details.show_details_form = this.$props.userDetails.show_details_form
    }
  },
  mounted() {
    if(this.modalOpen) {
      this.$bvModal.show('einvoicemodal')
    }
  },
  computed: {
      ...mapGetters(['getUserDetails', 'getResponseInfo']),
      clientName() {
      let clientName = clientShortName()
      return clientName
    }
  },
  components: {
    ResponseInfo
  }
}
</script>

<style scoped>
  .center-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>